import { z } from 'zod';

const index = z.number().int().nonnegative();
export const CutawayOpSchema = z.discriminatedUnion('op', [
  z.object({ index, op: z.literal('replace'), sceneId: z.string().min(1) }),
  z.object({ index, op: z.literal('shift'), deltaS: z.number().finite('Сдвиг врезки должен быть числом') }),
  z.object({ index, op: z.literal('remove') }),
]);

/** Keep the whole cutaway inside the output; a shift is relative to its saved position. */
export function clampCutawayShift(cutaway: { tl_in: number; tl_out: number }, deltaS: number, totalDuration: number): number {
  const duration = cutaway.tl_out - cutaway.tl_in;
  const latestStart = Math.max(0, totalDuration - duration);
  const target = Math.max(0, Math.min(latestStart, cutaway.tl_in + deltaS));
  return target - cutaway.tl_in;
}
